/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/pdgm', children: 'pdgm' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/PDGMLink.js